<script setup lang="ts">
import DateTimeFormatter from '@/components/formatters/DateTimeFormatter.vue';
import { computed } from 'vue';

const props = defineProps<{
  time?: string;
  user?: string | number | null;
  icon?: string;
  singleLine?: boolean;
}>();

const userString = computed(() => {
  if (typeof props.user === 'string' && props.user.toLocaleLowerCase() === 'ptw') {
    return props.user.toUpperCase();
  }
  return props.user;
});
</script>

<template>
  <span
    v-if="time"
    class="d-flex timestamp"
    :class="singleLine ? 'singleLine' : 'multiLine'"
    data-testid="timeStamp"
  >
    <v-icon
      v-if="icon"
      class="icon mr-1"
      :icon="icon"
      :size="18"
      :timestampType="icon"
      data-testid="timeStamp_icon"
    />

    <span class="text" data-testid="timeStamp_data">
      <DateTimeFormatter :value="time" class="timeInfo" />
      <span data-testid="timeStamp_user">{{ userString }}</span>
    </span>
  </span>
</template>

<style lang="scss" scoped>
.timestamp {
  align-items: center;

  .icon {
    align-self: center;
  }

  &.singleLine {
    .text {
      align-self: center;
      .timeInfo:after {
        content: ' | ';
      }
    }
  }

  &.multiLine {
    .icon {
      align-self: flex-start;
    }
    .text {
      display: flex;
      flex-direction: column;
      row-gap: 5px;
    }
  }
}
</style>
